import { Action } from 'redux';
import { BffFetchBonusesResponse } from '@lucky7ventures/bff-types';

export enum BonusesActionType {
  GetBonuses = 'GET_BONUSES',
  GetBonusesSuccess = 'GET_BONUSES_SUCCESS',
  GetBonusesError = 'GET_BONUSES_ERROR',
  ResetBonusesState = 'RESET_BONUSES_STATE',
  ShowPushNotificationBonus = 'SHOW_PUSH_NOTIFICATION_BONUS',
}

export type GetBonusesAction = Action<BonusesActionType.GetBonuses>;
export type GetBonusesSuccessAction = Action<BonusesActionType.GetBonusesSuccess> & {
  bonuses: BffFetchBonusesResponse;
};
export type GetBonusesErrorAction = Action<BonusesActionType.GetBonusesError>;
export type ResetBonusesStateAction = Action<BonusesActionType.ResetBonusesState>;
export type ShowPushNotificationBonusAction =
  Action<BonusesActionType.ShowPushNotificationBonus> & {
    bonusId: string;
  };

export type BonusesActions =
  | GetBonusesAction
  | GetBonusesSuccessAction
  | GetBonusesErrorAction
  | ResetBonusesStateAction
  | ShowPushNotificationBonusAction;

export const getBonuses = (): GetBonusesAction => ({
  type: BonusesActionType.GetBonuses,
});

export const getBonusesSuccess = (bonuses: BffFetchBonusesResponse): GetBonusesSuccessAction => ({
  type: BonusesActionType.GetBonusesSuccess,
  bonuses,
});

export const getBonusesError = (): GetBonusesErrorAction => ({
  type: BonusesActionType.GetBonusesError,
});
export const resetBonusesState = (): ResetBonusesStateAction => ({
  type: BonusesActionType.ResetBonusesState,
});

export const showPushNotificationBonus = (bonusId: string): ShowPushNotificationBonusAction => ({
  type: BonusesActionType.ShowPushNotificationBonus,
  bonusId,
});
